export default "__VITE_ASSET__6So7U6AZ__"